/**
 * Resolves a display name from the authenticated user object.
 * Checks full_name, user_metadata.full_name, then falls back to email-derived name.
 */
export function getCurrentRepName(
  user: { full_name?: string; user_metadata?: Record<string, unknown>; email?: string } | null,
): string {
  const metadataName =
    typeof user?.user_metadata?.full_name === "string"
      ? user.user_metadata.full_name
      : "";

  const explicitName = user?.full_name || metadataName;
  if (explicitName?.trim()) return explicitName.trim();

  if (user?.email) {
    const localPart = user.email.split("@")[0] || "";
    return localPart
      .split(/[._-]+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }

  return "";
}
